var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('el-upload', _vm._g(_vm._b({
    attrs: {
      "action": _vm.action
    }
  }, 'el-upload', _vm.$attrs, false), _vm.$listeners), [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v(" " + _vm._s(_vm.$attrs.btnText || "上传文件") + " ")])], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };